import ApiClient from '../ApiClient';

class SuperAdminFeatureFlagsAPI extends ApiClient {
  constructor() {
    super('super_admin/feature_flags', { apiVersion: 'v1' });
  }
}

export default new SuperAdminFeatureFlagsAPI();
